import * as React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/react-hooks';
import { createStore } from '../store';
import SearchForm from './SearchForm/SearchForm';
import { useGraphQLClient } from '../../graphql-client';
import { useConfig } from '../../context';
import { useRenderers } from '../../renderProps';
import Analytics from '../../Engine/components/Analytics';
import { BootstrapGate } from '@shared/ui';
let store = null;
const Component = props => {
    const client = useGraphQLClient();
    const { SearchFormWithStore: SearchFormWithStoreOverride = SearchForm } = useRenderers();
    const { SearchForm: { proMode, passengersConfig, offerHotels, offerHotelsDefaultState } } = useConfig();
    if (!store) {
        store = createStore(props.defaultParameters, passengersConfig, proMode, offerHotels ? offerHotelsDefaultState : false);
    }
    return (React.createElement(BootstrapGate, null,
        React.createElement(Provider, { store: store },
            React.createElement(ApolloProvider, { client: client },
                React.createElement(Analytics, null),
                React.createElement(SearchFormWithStoreOverride, Object.assign({}, props))))));
};
export { store };
export default Component;
